import approval from "./approval";
import archive from "./archive";
import attendance from "./attendance";
import content from "./content";
import point from "./point";
import zhijiaotong from "./zhijiaotong";

/**
 * 华博特项目接口文档
 */
export default {
  approval,
  archive,
  attendance,
  content,
  point,
  zhijiaotong,
};
